import { render } from "./CalendarRoom.vue?vue&type=template&id=ba2e7ef4&scoped=true"
import script from "./CalendarRoom.vue?vue&type=script&lang=js"
export * from "./CalendarRoom.vue?vue&type=script&lang=js"

import "./CalendarRoom.vue?vue&type=style&index=0&id=ba2e7ef4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2e7ef4"]])

export default __exports__